import * as yup from 'yup';
import { Dayjs } from 'dayjs';
import { CustomFieldType } from 'types/types/Types';

export const addRegistryCaseSchema = yup.object({
    patient_first_name: yup.string().required('First name is required'),
    patient_last_name: yup.string().required('Last name is required'),
    gender: yup.string().required('Gender is required'),
    date_of_birth: yup.mixed<Dayjs>().nullable().defined(),
    mrn: yup.string().defined(),
    insurance: yup.string().defined(),
    institute: yup
        .number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .required('Institution is required'),
    date: yup
        .mixed<Dayjs>()
        .required('Date of procedure is required'),
    type: yup.string().required('Procedure type is required'),
    vendors: yup.string().defined(),
    findings: yup.string().defined(),
    complications: yup.string().defined(),
    outcome: yup.string().defined(),
    diagnosisCodes: yup
        .array()
        .of(
            yup.object({
                id: yup.string().optional(),
                code: yup.string().required('ICD code is required'),
                value: yup.string().required('ICD value is required'),
            })
        )
        .defined(),
    cptCodes: yup
        .array()
        .of(
            yup.object({
                id: yup.string().optional(),
                code: yup.string().required(),
                value: yup.string().required(),
                rvu_value: yup.number().required(),
                quantity: yup.number().min(1).defined(),
            })
        )
        .defined(),
    notes: yup.array().of(yup.string().defined()).defined(),
});

export const buildDynamicSchema = (fields: CustomFieldType[]) => {
  const schemaShape: Record<string, yup.AnySchema> = {};

  fields.forEach((field) => {
    if (!field.visible) return;

    let validator: yup.AnySchema;

    switch (field.type) {
      case "Free text":
        validator = yup.string();
        break;

      case "Drop down list":
        validator = yup.string();
        break;

      case "Date":
        validator = yup.mixed<Dayjs>().nullable();
        break;

      default:
        validator = yup.mixed();
    }

    if (field.required) {
      validator = validator.required(`${field.property ?? field.name} is required`);
    } else {
      validator = validator.optional();
    }

    schemaShape[field.name] = validator;
  });

  return yup.object().shape(schemaShape);
};